import { keyboardKey, SpacebarKey } from '../../keyboard-key';
import { IS_FOCUSABLE_ATTRIBUTE } from '../../attributes';
export var pillBehavior = function pillBehavior(p) {
  var _Object$assign;
  return {
    attributes: {
      root: Object.assign((_Object$assign = {
        role: p.actionable || p.selectable ? 'button' : 'none',
        tabIndex: p.actionable || p.selectable ? 0 : -1
      }, _Object$assign[IS_FOCUSABLE_ATTRIBUTE] = p.actionable || p.selectable || p.role === 'option', _Object$assign), p.selectable && {
        'aria-selected': p.selected
      })
    },
    keyActions: {
      root: Object.assign({}, p.dismissible && {
        performDismiss: {
          keyCombinations: [{
            keyCode: keyboardKey.Delete
          }, {
            keyCode: keyboardKey.Backspace
          }]
        }
      }, (p.selectable || p.actionable) && {
        performClick: {
          keyCombinations: [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        }
      })
    }
  };
};
//# sourceMappingURL=pillBehavior.js.map
